import { Component, Input } from "@angular/core";
import { ApiUser } from "@tytapp/api";
import { AppConfig } from "@tytapp/common/app-config";
import { environment } from "@tytapp/environment";
import { UserService } from "@tytapp/user";
import { SubSink } from "subsink";

@Component({
    selector: 'tyt-paywall',
    templateUrl: './paywall.component.html',
    styleUrls: ['./paywall.component.scss']
})
export class PaywallComponent {
    constructor(
        private userService: UserService,
        private appConfig: AppConfig
    ) {
    }

    subsink = new SubSink();

    ngOnInit() {
        this.subsink.add(
            this.userService.userChanged
                .subscribe(user => this.user = user)
        );
    }

    ngOnDestroy() {
        this.subsink.unsubscribe();
    }

    /**
     * The type of thing being blocked (ie "video", "podcast", "poll", etc)
     */
    @Input()
    noun: string;

    user: ApiUser;

    get userEntitled() {
        if (!this.user)
            return false;

        return this.user.entitled;
    }

    get upgradeUrl() {
        return `${environment.urls.accounts}/membership/change`;
    }

    get purchaseUrl() {
        return environment.urls.purchase;
    }

    get learnMoreUrl() {
        return `/membership-benefits`;
        // return `https://accounts.tytnetwork.com/faq`;
    }

    get cancelDate() {
        if (!this.user || !this.user.membership)
            return null;
        return this.user.membership.cancelled_at;
    }

    get purchaseText() {
        if (this.paywallReason === 'expired')
            return 'Renew your membership';
        if (this.paywallReason === 'canceled')
            return 'Restart your membership';
        return 'Become a Member';
    }

    get paywallReason() {
        if (this.userEntitled)
            return 'under-entitled';
        else if (!this.user || !this.user.membership)
            return 'never-member';
        else if (this.user.membership.cancelled_at != null)
            return 'canceled';
        else if (this.user.membership.cancelled_at == null && !this.user.membership.entitled)
            return 'expired';

        return 'unknown';
    }
}